<template>
  <vs-popup title="Conveyancing Services (QLD only)" :active.sync="sdsOrderPopUp">
    <seller-disclosure-statement :display-type="'topUp'" :sds-orders="paymentRequest.sdsOrders" ref="sellerDisclosureStatementFields" v-on="$listeners" @updateSdsDetails="setSdsDetails" />
    <div class="popup-action-btn-container flex justify-end">
      <vs-button size="large" @click="handleSubmit" action-btn :disabled="sdsOrderButtonDisable">Order statement</vs-button>
      <vs-button color="danger" @click="handleCancel" size="large" action-btn class="ml-6 md:ml-10" :disabled="sdsOrderButtonDisable">Cancel</vs-button>
    </div>
  </vs-popup>
</template>

<script>
  import { mapActions } from "vuex";
  import SellerDisclosureStatement from "./SellerDisclosureStatement.vue";

  export default {
    components: {
      SellerDisclosureStatement,
    },

    props: {
      paymentRequest: {
        type: Object
      },
      prId: {
        type: String
      }
    },

    data() {
      return {
        sdsOrderButtonDisable: true,
        sdsOrderItems: [],
        sdsOrderPopUp: false,
      }
    },

    methods: {
    ...mapActions("paymentRequest", ["sellerDisclosureStatementOrder"]),

      handleSdsPopUp() {
        this.clearErrors();
        this.sdsOrderPopUp = !this.sdsOrderPopUp;
      },

      handleCancel() {
        this.handleSdsPopUp();
      },

      async handleSubmit() {
        this.sdsOrderButtonDisable = true;

        const obj = {
          data: {
            sdsOrderItems: this.sdsOrderItems
          },
          id: this.prId,
        };

        this.$vs.loading();

        await this.sellerDisclosureStatementOrder(obj).then(result => {
          this.$vs.loading.close();
          this.showMessage("Success", "Seller disclosure statement ordered successfully.", "success", "icon-check-circle");
          this.sdsOrderPopUp = false;
          this.$emit("update");
        }).catch(ex => {
          this.$vs.loading.close();
          this.showMessage("Failed", ex.data.message, "danger", "icon-times-circle");
        });

        this.sdsOrderButtonDisable = false;
      },

      showMessage(title, message, color, icon) {
        this.$vs.notify({
          title: title,
          text: message,
          color: color,
          iconPack: "feather",
          position: "top-right",
          icon: icon,
        });
      },

      addPopUpClass(enabled) {
        if (enabled) {
          document.body.classList.add("custom-popup", "decline-popup", "sds-popup");
        } else {
          document.body.classList.remove("custom-popup", "decline-popup", "sds-popup");
        }
      },

      setSdsDetails(data) {
        this.sdsOrderItems = data.sdsOrderItems;
        this.sdsOrderButtonDisable = (!this.sdsOrderItems.length || this.errors.items.length > 0);
      },

      async clearErrors() {
        this.errors.clear();
      },
    },

    watch: {
      async sdsOrderPopUp(val) {
        this.addPopUpClass(val);

        if (val) {
          await this.$refs.sellerDisclosureStatementFields.setDefaults();
        } else {
          await this.$refs.sellerDisclosureStatementFields.resetSdsOrderFields();
        }

        if (val && (this.errors.items.length > 0)) {
          await this.$refs.sellerDisclosureStatementFields.clearErrors();
          this.$emit("clearComponentError");
        }
      },
    }
  }
</script>